export default {"src":"/_next/static/image/public/images/ic_whatsapp.17e9f5fc20bafc3693acd7fbdec6ecea.svg","height":36,"width":36};